import { Col, Grid, Row } from 'react-bootstrap'

import Plot from 'react-plotly.js'
import PropTypes from 'prop-types'
import React from 'react'
import { axios } from 'config/axios'
import { getEmStats } from '../../api/ispyb.js'

export default class EmStatsPanel extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      movieNumber: [],
      averageData: [],
      defocusU: [],
      defocusV: [],
      resolution: [],
      angle: [],
      resolutionDistribution: [],
      defocusUDistribution: [],
      defocusVDistribution: [],
      angleDistribution: [],
      fetching: true,
      fetched: false,
      error: null,
    }
  }

  /**
   * This method will retrieve the dataCollections for a given session
   */
  componentDidMount() {
    const _this = this
    const movieNumber = []
    const averageData = []
    const defocusU = []
    const defocusV = []
    const resolution = []
    const angle = []
    const defocusDifference = []
    let resolutionDistribution = []
    let defocusUDistribution = []
    let defocusVDistribution = []
    let angleDistribution = []
    axios({
      method: 'GET',
      url: getEmStats(_this.props.user, _this.props.proposal, _this.props.sessionId),
    })
      .then(function (response) {
        response.data.sort(function (a, b) {
          return a.movieId - b.movieId
        })
        const startMovieId = response.data[0].movieId
        for (let i = 0; i < response.data.length; i++) {
          movieNumber.push(parseFloat(response.data[i].movieId - startMovieId + 1))
          averageData.push(parseFloat(response.data[i].averageMotionPerFrame))
          const U = parseFloat(response.data[i].defocusU) / 10000.0
          const V = parseFloat(response.data[i].defocusV) / 10000.0
          defocusU.push(U)
          defocusV.push(V)
          defocusDifference.push(Math.abs(U - V) / ((U + V) / 2.0))
          resolution.push(parseFloat(response.data[i].resolutionLimit))
          angle.push(parseFloat(response.data[i].angle))
        }
        resolutionDistribution = _this.getDistribution(resolution)
        defocusUDistribution = _this.getDistribution(defocusU)
        defocusVDistribution = _this.getDistribution(defocusV)
        angleDistribution = _this.getDistribution(angle)
        _this.setState({
          movieNumber: movieNumber,
          averageData: averageData,
          defocusU: defocusU,
          defocusV: defocusV,
          resolution: resolution,
          resolutionDistribution: resolutionDistribution,
          defocusUDistribution: defocusUDistribution,
          defocusVDistribution: defocusVDistribution,
          angleDistribution: angleDistribution,
          angle: angle,
          defocusDifference: defocusDifference,
          fetching: false,
          fetched: true,
        })
      })
      .catch(function (error) {
        _this.setState({
          error: error,
          fetching: false,
          fetched: false,
        })
      })
  }

  getLength(min, max, data) {
    let count = 0

    for (let i = 0; i < data.length; i++) {
      if (data[i] >= min && data[i] <= max) {
        count = count + 1
      }
    }

    return count
  }

  getDistribution(data) {
    const max = Math.max.apply(null, data)
    const min = Math.min.apply(null, data)
    const intervals = 50
    const distribution = []
    const size = (max - min) / intervals

    if (min > 0) {
      distribution.push([0, 0])
    }
    for (let i = min; i < max; i = i + size) {
      const localmin = i
      const localmax = localmin + size
      distribution.push([localmin.toFixed(3), this.getLength(localmin, localmax, data)])
    }

    return distribution
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12} sm={12} md={12} lg={6}>
            <Plot
              data={[
                {
                  x: this.state.movieNumber,
                  y: this.state.resolution,
                  type: 'scatter',
                  mode: 'markers',
                  marker: { color: 'blue', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Image no' } },
                yaxis: { title: { text: 'Angstroms' } },
                autosize: true,
                title: 'Resolution',
              }}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <Plot
              data={[
                {
                  x: this.state.resolutionDistribution.map(function (value) {
                    return value[0]
                  }),
                  y: this.state.resolutionDistribution.map(function (value) {
                    return value[1]
                  }),
                  type: 'bar',
                  marker: { color: 'blue', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Angstroms' } },
                autosize: true,
                title: 'Resolution distribution',
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={6}>
            <Plot
              data={[
                {
                  x: this.state.movieNumber,
                  y: this.state.angle,
                  type: 'scatter',
                  mode: 'markers',
                  marker: { color: 'blue', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Image no' } },
                yaxis: { title: { text: 'Degrees' } },
                autosize: true,
                title: 'Astigmatism (angle)',
              }}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <Plot
              data={[
                {
                  x: this.state.angleDistribution.map(function (value) {
                    return value[0]
                  }),
                  y: this.state.angleDistribution.map(function (value) {
                    return value[1]
                  }),
                  type: 'bar',
                  marker: { color: 'blue', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Degrees' } },
                autosize: true,
                title: 'Astigmatism (angle) distribution',
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={4}>
            <Plot
              data={[
                {
                  x: this.state.movieNumber,
                  y: this.state.defocusU,
                  name: 'Defocus U',
                  type: 'scatter',
                  mode: 'markers',
                  marker: { color: 'blue', size: 4 },
                },
                {
                  x: this.state.movieNumber,
                  y: this.state.defocusV,
                  name: 'Defocus V',
                  type: 'scatter',
                  mode: 'markers',
                  marker: { color: 'red', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Image no' } },
                yaxis: { title: { text: 'Microns' } },
                autosize: true,
                title: { text: 'Defocus U and Defocus V' },
              }}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={4}>
            <Plot
              data={[
                {
                  x: this.state.movieNumber,
                  y: this.state.defocusDifference,
                  type: 'scatter',
                  mode: 'markers',
                  marker: { color: 'blue', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Image no' } },
                yaxis: { title: { text: 'Microns' } },
                autosize: true,
                title: 'Defocus U - Defocus V',
              }}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={4}>
            <Plot
              data={[
                {
                  x: this.state.defocusUDistribution.map(function (value) {
                    return value[0]
                  }),
                  y: this.state.defocusUDistribution.map(function (value) {
                    return value[1]
                  }),
                  name: 'Defocus U',
                  type: 'bar',
                  marker: { color: 'blue', size: 4 },
                },
                {
                  x: this.state.defocusVDistribution.map(function (value) {
                    return value[0]
                  }),
                  y: this.state.defocusVDistribution.map(function (value) {
                    return value[1]
                  }),
                  name: 'Defocus V',
                  type: 'bar',
                  marker: { color: 'red', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Microns' } },
                autosize: true,
                title: 'Defocus distribution',
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Plot
              data={[
                {
                  x: this.state.movieNumber,
                  y: this.state.averageData,
                  type: 'scatter',
                  mode: 'markers',
                  marker: { color: 'blue', size: 4 },
                },
              ]}
              useResizeHandler
              style={{ width: '100%' }}
              layout={{
                xaxis: { title: { text: 'Image no' } },
                autosize: true,
                title: 'Average motion per frame',
              }}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

EmStatsPanel.propTypes = {
  user: PropTypes.object,
  proposal: PropTypes.string,
  sessionId: PropTypes.string,
}
